import Vue from 'vue'
import App from './App.vue'
import i18n from './i18n'
import VueTippy, { TippyComponent } from 'vue-tippy'

import './assets/scss/main.scss'
import 'tippy.js/themes/light.css'

import 'css.escape'
import 'notyf/notyf.min.css'

Vue.config.productionTip = false
window.Office.onReady(() => {
  new Vue({
    i18n,
    render: h => h(App),
  }).$mount('#app')

  Vue.use(VueTippy, {
    theme: 'light',
  })
  Vue.component('Tippy', TippyComponent)

  const liveTranslatorUrl = process.env.VUE_APP_LIVE_TRANSLATOR_URL
  if (liveTranslatorUrl && liveTranslatorUrl.startsWith('https://')) {
    import('vue-i18n-live-translator-plugin').then(({ LiveTranslatorPlugin }) => {
      Vue.use(LiveTranslatorPlugin, {
        i18n,
        translationLink (meta) {
          return `${liveTranslatorUrl}/${meta.locale}/?q=context:=${meta.path}`
        },
        persist: true,
        root: document.getElementById('app'),
        refreshRate: 200,
        checkVisibility: true,
      })
    })
  }
})
